
import { request, url } from '@tencent/ppd-base-libs';
import { PageResult } from './types';
import { MerchantInfo } from '../../type';
import { amount } from '@tencent/wphk-base-utils';

// debugger模式处理
const isDebugger = url.getUrlParam('wecoupon_debugger') === '1';
const debugOptions = isDebugger ? { is_debug: 1 } : {};

/**
 * 获取券分类列表信息
 * @returns
 */
export async function getClassList() {
  const url = '/app/promotion/we_coupon/we_coupon_get_classes.cgi';
  return await request.get(url, { params: debugOptions });
}


/**
 * 获取指定分类下的券列表信息
 * @param classId 分类ID
 * @param offset 数据偏移量
 * @param limit 获取数据个数
 * @returns
 */
export async function getCouponListByClassId(classId: string, offset: number, limit: number):
Promise<PageResult<any>> {
  const url = '/app/promotion/we_coupon/we_coupon_home.cgi';
  const {
    has_next_page: hasNextPage,
    total_num: totalCount,
    coupon_array: dataList,
  } = await request.get(url, { params: { class_id: classId, offset, limit, ...debugOptions } });
  return { hasNextPage, totalCount, dataList };
}

/**
 * 批量领取商户下券
 * @returns
 */
export async function batchGetBySPId(spId: string) {
  const url = '/app/promotion/we_coupon/we_coupon_batch_get.cgi';
  return await request.get(url, { params: { spid: spId, ...debugOptions } });
}

/**
 * 获取商户下券列表信息
 * @returns
 */
export async function getCouponListBySPId(spId: string, offset: number, limit: number) {
  const url = '/app/promotion/we_coupon/we_coupon_get_sp_coupon.cgi';
  const {
    coupon_array: couponList = [],
    has_next_page: hasNextPage = false,
  } = await request.get(url, { params: {
    spid: spId, offset, limit,
    ...debugOptions,
  } });
  return {
    couponList: couponList as any[],
    hasNextPage: !!hasNextPage,
  };
}

/**
 * 获取分类下的商户列表信息
 * @param classId 分类ID
 * @param offset 数据偏移量
 * @param limit 数据量
 * @returns
 */
export async function getSPListByClassId(
  classId: string,
  offset: number, limit: number,
): Promise<PageResult<MerchantInfo>> {
  const url = '/app/promotion/we_coupon/we_coupon_class_info.cgi';
  const res = await request.get(url, { params: { class_id: classId, offset, limit, ...debugOptions } });
  return {
    totalCount: res.total_num,
    dataList: res.sp_array.map(item => ({
      spId: item.spid,
      spLogo: item.sp_logo,
      spName: item.sp_name,
      totalValue: +amount.fen2Yuan(item.total_value),
      state: +item.state,
      currencyType: item.cur_type,
      totalCnt: +item.total_cnt,
    })),
  };
}

/**
 * 根据商户 id 拉取商户信息
 * @param spId 商户 id
 */
export async function getSPInfoBySPId(spId: string): Promise<MerchantInfo> {
  const url = '/app/promotion/we_coupon/we_coupon_sp_info.cgi';
  const res = await request.get(url, { params: { spid: spId } });
  return {
    spId,
    spLogo: res.sp_logo,
    spName: res.sp_name,
    totalValue: +amount.fen2Yuan(res.total_value),
    state: 2,
  };
}

